import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./styles/app.css";
import "./styles/cbt.css";
import "./index.css";
import PreLogin from "./pages/PreLogin";
import Login from "./pages/Login";
import Cbt from "./pages/CBT";
import Homework from "./pages/Homework";
import Locker from "./pages/Locker";
import Notes from "./pages/Notes";
import VideoLessons from "./pages/VideoLessons";
import CheckResults from "./pages/CheckResults";
import Resources from "./pages/Resources";
import VirtualClassroom from "./pages/VirtualClassroom";
import Attendance from "./pages/Attendance";
import AttendanceAllTerms from "./pages/AttendanceAllTerms";
import Timetable from "./pages/Timetable";
import ViewHomework from "./pages/ViewHomework";
import AnswersReview from "./pages/AnswersReview";
import AppShell from "./AppShell";
import CbtShell from "./components/CbtShell";
import ChatroomShell from "./components/ChatroomShell";
import ChatPage from "./pages/ChatPage";
import CbtTest from "./pages/CbtTest";
import OnGoingTest2 from "./pages/OnGoingTest2";
import OnGoingTest from "./pages/OnGoingTest";
import { AuthProvider } from "./context/AuthContext";
import { DataProvider } from "./context/DataContext";
// import { DataContext } from './context/DataContext'
import MobileChatPage from "./pages/MobileChatPage";
import FourOFour from "./pages/FourOFour";
import axios from "axios";
import { createBrowserHistory } from "history";
import ReactGA from "react-ga";

const schoolUrl = window.location.host;
let schoolDomain = "nill";
if (schoolUrl.includes("localhost")) {
  // schoolDomain = "s-teeschool.edves.net"
  schoolDomain = "demo.edves.net";
  // schoolDomain = "dijs.edves.net"
} else {
  schoolDomain = schoolUrl;
}
localStorage.setItem("schoolDomain", schoolDomain);

console.log(schoolDomain);

const ShellRoutes = ({ children, ...rest }) => {
  return <Route {...rest} render={() => <AppShell> {children} </AppShell>} />;
};

const CbtRoutes = ({ children, ...rest }) => {
  return <Route {...rest} render={() => <CbtShell> {children} </CbtShell>} />;
};

const ChatroomRoutes = ({ children, ...rest }) => {
  return (
    <Route
      {...rest}
      render={() => <ChatroomShell> {children} </ChatroomShell>}
    />
  );
};

const Approutes = () => {
  return (
    <Router basename={"/students"}>
      <Switch>
        <Route exact path='/'>
          <PreLogin />
        </Route>
        <Route path='/login'>
          <Login />
        </Route>
        <Route path='/test'>
          <CbtTest />
        </Route>
        <Route path='/ongoingtest2'>
          <OnGoingTest2 />
        </Route>

        <Route path='/ongoingtest'>
          <OnGoingTest />
        </Route>

        <Route path='/answers-review'>
          <AnswersReview />
        </Route>
        <Route path='/mobileChatroom'>
          <MobileChatPage />
        </Route>

        {/* <CbtRoutes path='/cbt'>
          <Cbt />
        </CbtRoutes> */}
        <CbtRoutes
          path='/cbt'
          component={() => {
            return schoolDomain === "demo.edves.net" ||
              schoolDomain === "demogh.edves.net" ? (
              <CbtRoutes path='/cbt'>
                <Cbt />
              </CbtRoutes>
            ) : (
              (window.location.href = `https://${schoolDomain}/cbt`)
            );
          }}
        />

        <ChatroomRoutes path='/chatroom'>
          <ChatPage />
        </ChatroomRoutes>

        <ShellRoutes path='/clickedMenu'>
          <MobileChatPage />
        </ShellRoutes>
        <ShellRoutes path='/homework'>
          <Homework />
        </ShellRoutes>
        <ShellRoutes path='/locker'>
          <Locker />
        </ShellRoutes>
        <ShellRoutes path='/notes'>
          <Notes />
        </ShellRoutes>
        <ShellRoutes path='/video'>
          <VideoLessons />
        </ShellRoutes>
        <ShellRoutes path='/checkResults'>
          <CheckResults />
        </ShellRoutes>
        <ShellRoutes path='/resources'>
          <Resources />
        </ShellRoutes>
        <ShellRoutes path='/virtualClassroom'>
          <VirtualClassroom />
        </ShellRoutes>
        <ShellRoutes path='/filterAttendance'>
          <AttendanceAllTerms />
        </ShellRoutes>
        <ShellRoutes path='/attendance'>
          <Attendance />
        </ShellRoutes>
        <ShellRoutes path='/timetable'>
          <Timetable />
        </ShellRoutes>
        <ShellRoutes path='/viewHomework'>
          <ViewHomework />
        </ShellRoutes>

        <Route path='*'>
          <FourOFour />
        </Route>
      </Switch>
    </Router>
  );
};

function App() {
  const history = createBrowserHistory();
  // const dataContext = useContext(DataContext);
  let schoolDomain;
  let studentInfo;
  let studentId;
  if (
    localStorage.getItem("schoolDomain") &&
    localStorage.getItem("studentInfo")
  ) {
    schoolDomain = localStorage.getItem("schoolDomain");
    studentInfo = JSON.parse(localStorage.getItem("studentInfo"));
    studentId = studentInfo[0].studentId;
  }

  const TRACKING_ID = "UA-23405765-9"; // TRACKING_ID
  ReactGA.initialize(TRACKING_ID);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    return () => {};
  });

  history.listen((location) => {
    ReactGA.set({ page: location.pathname }); // Update the user's current page
    ReactGA.pageview(location.pathname + window.location.search); // Record a pageview for the given page
  });

  // let _gaq =  [];
  // _gaq.push(['_setAccount', 'UA-23405765-9']);
  // _gaq.push(['_setDomainName', '.edves.net]']);
  // _gaq.push(['_trackPageview']);
  // const googleAnalytics = () => {
  //   var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
  //   ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
  //   var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
  // };
  // googleAnalytics();

  useEffect(() => {
    const getGroups = async () => {
      try {
        const { data } = await axios.get(
          `student/groups/${schoolDomain}/${studentId}`
        );
        console.log(data);
        const groups = data.data;
        if (data.status) {
          localStorage.setItem("chatGroups", JSON.stringify(groups));
        } else {
          console.log(data.message);
        }
      } catch (error) {
        console.log("fetch messages error", error);
      }
    };

    if (schoolDomain && studentInfo && studentId) getGroups();
  }, []);

  return (
    <Router history={history}>
      <AuthProvider>
        <DataProvider>
          <div>
            <Approutes />
          </div>
        </DataProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
